import {Component} from "@angular/core";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {IndemnitesAbattementItem} from "@components/admin/frais/indemnites/indemnites-abattements/indemnites-abattements.component";

/**
 * Composant d'affichage d'un abattement en mode tags
 */
@Component({
    host: {'data-test-id': 'indemnites-abattements-list-item'},
    selector: 'indemnites-abattements-list-item',
    templateUrl: './indemnites-abattements-list-item.component.html'
})
export class IndemnitesAbattementsListItemComponent extends ListViewItem<IndemnitesAbattementItem> {
    /**
     * Consultation de l'élément courant
     */
    consultAbattement(): void {
        //Délégation au composant parent
        this.extraOptions?.consultAbattement?.(this.data);
    }

    /**
     * Suppression de l'élément courant
     */
    deleteAbattement(): void {
        //Délégation au composant parent
        this.extraOptions?.deleteAbattement?.(this.data);
    }
}
